import {Component, Input} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {Offer} from 'src/app/model/offer/offer';
import {OfferFormBase} from '../offer-form-base/offer-form-base.component';
import {CustomValidators} from '../../../../../validator/custom-validator';
import {Ratio} from '../../../../../model/ratio';
import {Store} from '@ngrx/store';
import {ProposalAppState} from '../../../../../store/proposal/reducers/proposal.reducer';
import {
  selectDetailPageCreateOfferHasLeading,
  selectDetailPageCreateOfferNeedsFollowing
} from '../../../../../store/proposal/selectors/proposal.selectors';
import {debounceTime} from 'rxjs';

@Component({
    selector: 'app-coverage-information',
    templateUrl: './coverage-information.component.html',
    styleUrls: ['./coverage-information.component.scss', '../../../../../../styles/form-input.scss'],
    providers: [{ provide: OfferFormBase, useExisting: CoverageInformationComponent }],
    standalone: false
})
export class CoverageInformationComponent extends OfferFormBase {

  showLeading: boolean;

  Ratio = Ratio;
  @Input() maxCoverage = 100;
  hasLeading$ = this.proposalStore.select(selectDetailPageCreateOfferHasLeading);
  needsFollowing$ = this.proposalStore.select(selectDetailPageCreateOfferNeedsFollowing);

  formGroup = this.fb.group({
    isLeading: new FormControl<boolean>(null, [Validators.required]),
    amountCovered: new FormControl<number>(null, [Validators.required, CustomValidators.validNumber({
      allowZero: true
    })]),
  });

  ngOnInit() {
    this.hasLeading$.subscribe((hasLeading) => this.formGroup.controls.isLeading.setValue(!hasLeading));
    this.formGroup.controls.amountCovered.valueChanges.pipe(debounceTime(100)).subscribe((value) => {
        this.dispatchInputEventPercent();

        if (value === 100) {
          this.showLeading = false;
          this.formGroup.controls.isLeading.disable();
          this.formGroup.value.isLeading = true;
        } else {
          this.showLeading = true;
          this.formGroup.controls.isLeading.enable();
        }
      }
    );
    this.formGroup.controls.amountCovered.setValue(this.maxCoverage);
  }

  constructor(private readonly fb: FormBuilder, private readonly proposalStore: Store<ProposalAppState>) {
    super();
  }

  updateOffer(offer: Offer): void {
    offer.isLeading = this.formGroup.value.isLeading;
    offer.amountCovered =this.formGroup.value.amountCovered / 100;
  }

  dispatchInputEventPercent() {
    const input = document.querySelector('input[formControlName=\'amountCovered\']');
    input.dispatchEvent(new Event('convertNumber'));
  }

  prefill(offer: Offer) {
    this.formGroup.patchValue({
      isLeading: offer.isLeading ?? null,
      amountCovered: offer.amountCovered ? offer.amountCovered * 100 : null
    });
  }
}
